class EventBus {
  private static instance: EventBus;
  private events: { [key: string]: Function[] };

  private constructor() {
    this.events = {};
  }

  public static getInstance(): EventBus {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus();
    }
    return EventBus.instance;
  }

  public subscribe(eventName: string, callback: Function): string {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    if (!this.events[eventName].includes(callback)) {
      this.events[eventName].push(callback);
    }
    return `${eventName}-${this.events[eventName].length - 1}`;
  }

  public unsubscribe(subscriptionId: string): void {
    const [eventName, index] = subscriptionId.split("-");
    this.events[eventName].splice(parseInt(index), 1);
  }

  public clear(): void {
    this.events = {};
  }

  public emit(eventName: string, ...args: any[]): void {
    const eventCallbacks = this.events[eventName];
    if (eventCallbacks) {
      eventCallbacks.forEach((callback) => {
        callback(...args);
      });
    }
  }
}

export const eventBus = EventBus.getInstance();
